import MetaBillingsCargoTaxiStatusCountersResponse from "../../../../../api/raily/meta/billings/cargo-taxi/status-counters/meta-billings-cargo-taxi-status-counters.response";
import MetaBillingsCargoTaxiStatusCounters from "./meta-billings-cargo-taxi-status-counters";

const create = (
  response: MetaBillingsCargoTaxiStatusCountersResponse,
): MetaBillingsCargoTaxiStatusCounters => {
  const data = response.data;
  return {
    accepted: data.accepted,
    created: data.created,
    total: data.total,
    rejected: data.rejected,
    reopenRequest: data.reopenRequest,
    reopened: data.reopened,
  };
};

const metaBillingsCargoTaxiStatusCountersFactory = {
  create,
};

export default metaBillingsCargoTaxiStatusCountersFactory;
